import Loadable from '../../../../components/loadable';

export default Loadable(() =>
  import(/* webpackChunkName: "listrules" */ './index')
);
